// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Snapshot(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Snapshot" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M6 6H9V4H4V9H6V6Z", fill: "currentColor" }),
            React.createElement("path", { d: "M18 6H15V4H20V9H18V6Z", fill: "currentColor" }),
            React.createElement("path", { d: "M18 18H15V20H20V15H18V18Z", fill: "currentColor" }),
            React.createElement("path", { d: "M6 18H9V20H4V15H6V18Z", fill: "currentColor" }),
            React.createElement("path", { d: "M15.5 13V11H13V8.5H11V11H8.5V13H11V15.5H13V13H15.5Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Snapshot.js.map